import {createSlice} from "@reduxjs/toolkit";
import {ResponseApi} from '../BaseApi';
import {GetGeofenceConfigSettingByGeofenceId, GetGeofenceList} from "./AttendanceGeofenceApi";

/**
 * @Author: Arnulfo ferro Zapata
 * @JobTitle: Full Stack Developer - IBL
 * @Email: azapata@ibl.mx
 */

const AttendanceGeofenceSlice = createSlice({
    name: "attendanceGeofence",
    initialState: {
        getGeofenceList: [],
        geofenceConfig: null
    },
    reducers: {
        resetGetGeofenceList: (state, action) => {
            state.getGeofenceList = [];
        },
    },
    extraReducers: (builder) => {
        builder.
        addCase(GetGeofenceList.fulfilled, (state, {payload}) =>{
            state.getGeofenceList = ResponseApi(payload);
        }).addCase(GetGeofenceConfigSettingByGeofenceId.fulfilled, (state, {payload}) =>{
            state.geofenceConfig = ResponseApi(payload);
        })
    }

})

export const {resetGetGeofenceList } = AttendanceGeofenceSlice.actions;

export default AttendanceGeofenceSlice.reducer;
